<template>
  <div class="code-btn" :class="{ 'gray': counting }" @click="sendCode">
    <span>{{txtStr}}</span>
  </div>
</template>

<script>
import { unValidMoblie, unValidImgCaptcha, unValidUserAccount } from '../libs/validate';
import { apiCode, apiIsShowCaptcha } from '../libs/service';

const times = 60;
export default {
  name: 'code-btn',
  props: {
    graph: { type: String, default: '' },
    mobile: { type: String, default: '' },
    type: { type: String, default: 'LOGIN' },
    imgCaptcha: { type: String, default: '' },
    account: { type: String, default: '' },
    isNeedSelectAccount: { type: Boolean, default: false },
  },
  data() {
    return {
      isInit: true,
      count: times,
      counting: false,
      isNeedImgCaptcha: false,
    };
  },
  created() {
    this.isNeedCaptcha();
  },
  computed: {
    txtStr() {
      if (this.count === times) {
        return this.isInit ? '获取验证码' : '重新获取';
      }
      return `发送成功，${this.count}s后重试`;
    },
    unValid() {
      let rt = unValidMoblie(this.mobile) || (this.isNeedImgCaptcha && unValidImgCaptcha(this.imgCaptcha)); // eslint-disable-line
      if (!rt && this.isNeedSelectAccount) {
        rt = unValidUserAccount(this.account);
      }
      return rt;
    },
  },
  methods: {
    sendCode() {
      this.isNeedCaptcha();
      if (this.count !== times || this.counting) {
        this.$emit('tipImgCaptcha');
        return;
      }
      if (this.unValid) {
        this.$emit('tipImgCaptcha', this.unValid);
        return;
      }
      apiCode(this.graph, this.type, this.mobile, this.imgCaptcha, () => {
        this.countTimer();
        this.$emit('tipImgCaptcha');
      }, (msg) => {
        this.$emit('tipImgCaptcha', msg, true);
      });
    },
    countTimer() {
      let timer = null;
      const runTime = () => {
        if (!this.count) {
          clearInterval(timer);
          this.count = times;
          this.counting = false;
        } else {
          this.count -= 1;
          this.counting = true;
        }
      };
      this.isInit = false;
      // 1s执行一次
      runTime();
      timer = window.setInterval(() => {
        runTime();
      }, 1000);
    },
    // 点击获取验证码超过3次时出现图形验证码
    isNeedCaptcha() {
      apiIsShowCaptcha(this.graph, (isNeedImgCaptcha) => {
        this.isNeedImgCaptcha = isNeedImgCaptcha;
        this.$emit('updateCaptcha', isNeedImgCaptcha);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../libs/mixin.scss';

.code-btn {
  position: absolute;
  top: 5px;
  right: 0;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  z-index: 3;
  color: $mainColor;
  cursor: pointer;
  &.gray {
    color: #999;
  }
}
</style>
